<template>
	<div class="card-body">
		<div class="row row-cols-auto justify-content-md-between justify-content-end mb-2 mx-auto gap-2">
			<div class="col-12 col-md-auto p-0 d-inline-flex">
				<h5 class="my-auto">Data Kelengkapan Berkas Pendaftar</h5>
			</div>
			<div class="col-auto p-0" v-if="adminKhusus">
				<select class="form-select form-select-sm shadow-sm" v-model="ta">
					<option v-for="t in listTa" :key="t" :value="t">{{ t.nama }}</option>
				</select>
			</div>
			<div class="col-auto p-0" v-else>
				<h6 class="bg-white rounded px-2 py-1 shadow my-auto">{{ ta.nama }}</h6>
			</div>
		</div>
		<div class="row mb-2">
			<div class="col-12 col-sm-6 col-md-4 col-lg-3 ms-auto">
				<input id="cari" type="search" class="form-control form-control-sm shadow-sm" placeholder="Cari . . ." v-model="key" />
			</div>
		</div>
		<div class="table-responsive vl-parent shadow" ref="dataBerkas">
			<table class="table table-sm mb-0 text-nowrap">
				<thead class="table-secondary align-middle">
					<tr>
						<th>#</th>
						<th class="position-sticky start-0">No. Reg.</th>
						<th>Nama</th>
						<th>Kelengkapan</th>
						<th>Dibuat</th>
						<th>Diperbarui</th>
					</tr>
				</thead>
				<tbody v-if="dataKelengkapan.length">
					<tr v-for="(d, index) in dataKelengkapan" :key="d">
						<td>{{ (index += 1 + pageOffset) }}</td>
						<td class="position-sticky start-0">{{ d.no_reg }}</td>
						<td>
							<transition name="fade" mode="out-in">
								<div :key="d.nama">{{ d.nama }}</div>
							</transition>
						</td>
						<td>
							<div class="hstack gap-1 justify-content-between">
								<transition name="fade" mode="out-in">
									<div class="fw-bold" :style="'color:' + d.warna" :key="d.kelengkapan + ''">{{ d.kelengkapan }}%</div>
								</transition>
								<button class="btn btn-sm btn-outline-secondary d-flex border-0" v-tooltip="'Lihat detail'" @click="getBerkasPendaftarByPpdbId(d)">
									<svg xmlns="http://www.w3.org/2000/svg" width="13" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
										<path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
										<path
											d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
									</svg>
								</button>
							</div>
						</td>
						<td>
							<div class="fw-bold">{{ d.creator }}</div>
							<small class="fst-italic">{{ d.created_at }}</small>
						</td>
						<td>
							<transition name="fade" mode="out-in">
								<div class="fw-bold" :key="d.editor">{{ d.editor || "-" }}</div>
							</transition>
							<transition name="fade" mode="out-in">
								<small class="fst-italic" :key="JSON.stringify(d.updated_at)">{{ d.updated_at }}</small>
							</transition>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr>
						<td class="text-center fst-italic py-3" colspan="6">Data tidak ditemukan.</td>
					</tr>
				</tbody>
			</table>
		</div>
		<span v-if="dataKelengkapan.length" class="small text-muted fst-italic">
			Menampilkan {{ pageOffset + 1 }}-{{ pageOffset + dataKelengkapan.length }} dari total {{ count }} data
		</span>
	</div>
	<div v-if="dataKelengkapan.length" class="card-footer">
		<div class="row row-cols-auto justify-content-sm-between justify-content-center">
			<div class="row row-cols-auto">
				<label class="col-auto col-form-label-sm pe-1" for="numRows">Tampilkan:</label>
				<div class="col-auto ps-1">
					<select class="form-select form-select-sm shadow" v-model="pageLimit" id="numRows">
						<option v-for="l in arrayLimit" :key="l" :value="l">{{ l }} baris</option>
					</select>
				</div>
			</div>
			<div class="col-auto">
				<ul class="pagination pagination-sm shadow mb-0">
					<li class="page-item">
						<button class="page-link" :class="{ disabled: pageCurrent == 1 }" @click="pageCurrent > 1 ? pageCurrent-- : ''">&laquo;</button>
					</li>
					<li class="page-item" v-for="p in pageCount" :key="p">
						<button v-if="p == pageCurrent" class="page-link active fw-bold">{{ p }}</button>
						<button v-else-if="p == 1 || p == pageCount || Math.abs(p - pageCurrent) == 1" class="page-link" @click="pageCurrent = p">{{ p }}</button>
						<button
							v-else-if="(Math.abs(pageCurrent - 1) < 4 && Math.abs(p - 1) < 5) || (Math.abs(pageCurrent - pageCount) < 4 && Math.abs(p - pageCount) < 5)"
							class="page-link"
							@click="pageCurrent = p">
							{{ p }}
						</button>
						<button
							v-else-if="(Math.abs(p - 1) == 5 || Math.abs(p - pageCount) == 5) && (Math.abs(p - pageCount) == 1 || Math.abs(p - 1) == 1)"
							class="page-link"
							@click="pageCurrent = p">
							{{ p }}
						</button>
						<button
							v-else-if="
								Math.abs(p - pageCurrent) == 2 || (Math.abs(pageCurrent - 1) < 4 && Math.abs(p - 1) == 5) || (Math.abs(pageCurrent - pageCount) < 4 && Math.abs(p - pageCount) == 5)
							"
							class="page-link px-1"
							@click="pageCurrent = p">
							...
						</button>
					</li>
					<li class="page-item">
						<button class="page-link" :class="{ disabled: pageCurrent == pageCount }" @click="pageCurrent < pageCount ? pageCurrent++ : ''">&raquo;</button>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div class="modal fade" id="lihatDetail" aria-hidden="true" aria-labelledby="lihatDetail" data-bs-backdrop="static" data-bs-keyboard="false">
		<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<legend class="modal-title">Detail Berkas ~ ({{ pendaftar?.no_reg }}) {{ pendaftar?.nama }}</legend>
					<button type="button" id="tutupLihatBerkas" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<form @submit.prevent="perbaruiData">
					<div class="modal-body vl-parent" ref="detailBerkas">
						<h5>
							Persentase Kelengkapan: <strong :style="'color:' + pendaftar?.warna">{{ pendaftar?.kelengkapan }}%</strong>
						</h5>
						<table class="table table-bordered table-hover">
							<thead>
								<tr>
									<th>Jenis Berkas</th>
									<th>Foto</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Foto Diri</td>
									<td>
										<div class="input-group input-group-sm shadow" :class="{ 'mb-2': previews.fotoDiri }" v-show="edit">
											<input
												type="file"
												ref="fotoDiriRef"
												class="form-control form-control-sm"
												accept="image/*"
												@change="handleInputFoto($event, 'fotoDiri')"
												:disabled="loadingInput.fotoDiri" />
											<span class="input-group-text" v-show="loadingInput.fotoDiri">
												<span class="spinner-border spinner-border-sm text-secondary"></span>
											</span>
										</div>
										<img
											v-if="previews.fotoDiri"
											:src="previews.fotoDiri"
											style="max-width: 100%; max-height: 160px"
											class="shadow btn btn-outline-secondary p-1"
											alt=""
											@click="lihatFotoModal(previews.fotoDiri)"
											v-tooltip="'Lihat Foto'" />
										<span v-else-if="!edit">-</span>
									</td>
								</tr>
								<tr>
									<td>Kartu Keluarga</td>
									<td>
										<div class="input-group input-group-sm shadow" :class="{ 'mb-2': previews.kk }" v-show="edit">
											<input type="file" ref="kkRef" class="form-control form-control-sm" accept="image/*" @change="handleInputFoto($event, 'kk')" :disabled="loadingInput.kk" />
											<span class="input-group-text" v-show="loadingInput.kk">
												<span class="spinner-border spinner-border-sm text-secondary"></span>
											</span>
										</div>
										<img
											v-if="previews.kk"
											:src="previews.kk"
											style="max-width: 100%; max-height: 160px"
											class="shadow btn btn-outline-secondary p-1"
											alt=""
											@click="lihatFotoModal(previews.kk)"
											v-tooltip="'Lihat Foto'" />
										<span v-else-if="!edit">-</span>
									</td>
								</tr>
								<tr>
									<td>Akta Kelahiran</td>
									<td>
										<div class="input-group input-group-sm shadow" :class="{ 'mb-2': previews.akta }" v-show="edit">
											<input
												type="file"
												ref="aktaRef"
												class="form-control form-control-sm"
												accept="image/*"
												@change="handleInputFoto($event, 'akta')"
												:disabled="loadingInput.akta" />
											<span class="input-group-text" v-show="loadingInput.akta">
												<span class="spinner-border spinner-border-sm text-secondary"></span>
											</span>
										</div>
										<img
											v-if="previews.akta"
											:src="previews.akta"
											style="max-width: 100%; max-height: 160px"
											class="shadow btn btn-outline-secondary p-1"
											alt=""
											@click="lihatFotoModal(previews.akta)"
											v-tooltip="'Lihat Foto'" />
										<span v-else-if="!edit">-</span>
									</td>
								</tr>
								<tr>
									<td>SKL/Ijazah <i class="rounded rounded-circle text-bg-secondary px-1 small" v-tooltip="'Ijazah SMP/MTs atau SD/MI'">i</i></td>
									<td>
										<div class="input-group input-group-sm shadow" :class="{ 'mb-2': previews.skl }" v-show="edit">
											<input type="file" ref="sklRef" class="form-control form-control-sm" accept="image/*" @change="handleInputFoto($event, 'skl')" :disabled="loadingInput.skl" />
											<span class="input-group-text" v-show="loadingInput.skl">
												<span class="spinner-border spinner-border-sm text-secondary"></span>
											</span>
										</div>
										<img
											v-if="previews.skl"
											:src="previews.skl"
											style="max-width: 100%; max-height: 160px"
											class="shadow btn btn-outline-secondary p-1"
											alt=""
											@click="lihatFotoModal(previews.skl)"
											v-tooltip="'Lihat Foto'" />
										<span v-else-if="!edit">-</span>
									</td>
								</tr>
								<tr>
									<td>KTP Ayah</td>
									<td>
										<div class="input-group input-group-sm shadow" :class="{ 'mb-2': previews.ktpAyah }" v-show="edit">
											<input
												type="file"
												ref="ktpAyahRef"
												class="form-control form-control-sm"
												accept="image/*"
												@change="handleInputFoto($event, 'ktpAyah')"
												:disabled="loadingInput.ktpAyah" />
											<span class="input-group-text" v-show="loadingInput.ktpAyah">
												<span class="spinner-border spinner-border-sm text-secondary"></span>
											</span>
										</div>
										<img
											v-if="previews.ktpAyah"
											:src="previews.ktpAyah"
											style="max-width: 100%; max-height: 160px"
											class="shadow btn btn-outline-secondary p-1"
											alt=""
											@click="lihatFotoModal(previews.ktpAyah)"
											v-tooltip="'Lihat Foto'" />
										<span v-else-if="!edit">-</span>
									</td>
								</tr>
								<tr>
									<td>KTP Ibu</td>
									<td>
										<div class="input-group input-group-sm shadow" :class="{ 'mb-2': previews.ktpIbu }" v-show="edit">
											<input
												type="file"
												ref="ktpIbuRef"
												class="form-control form-control-sm"
												accept="image/*"
												@change="handleInputFoto($event, 'ktpIbu')"
												:disabled="loadingInput.ktpIbu" />
											<span class="input-group-text" v-show="loadingInput.ktpIbu">
												<span class="spinner-border spinner-border-sm text-secondary"></span>
											</span>
										</div>
										<img
											v-if="previews.ktpIbu"
											:src="previews.ktpIbu"
											style="max-width: 100%; max-height: 160px"
											class="shadow btn btn-outline-secondary p-1"
											alt=""
											@click="lihatFotoModal(previews.ktpIbu)"
											v-tooltip="'Lihat Foto'" />
										<span v-else-if="!edit">-</span>
									</td>
								</tr>
								<tr>
									<td>KTP Wali</td>
									<td>
										<div class="input-group input-group-sm shadow" :class="{ 'mb-2': previews.ktpWali }" v-show="edit">
											<input
												type="file"
												ref="ktpWaliRef"
												class="form-control form-control-sm"
												accept="image/*"
												@change="handleInputFoto($event, 'ktpWali')"
												:disabled="loadingInput.ktpWali" />
											<span class="input-group-text" v-show="loadingInput.ktpWali">
												<span class="spinner-border spinner-border-sm text-secondary"></span>
											</span>
										</div>
										<img
											v-if="previews.ktpWali"
											:src="previews.ktpWali"
											style="max-width: 100%; max-height: 160px"
											class="shadow btn btn-outline-secondary p-1"
											alt=""
											@click="lihatFotoModal(previews.ktpWali)"
											v-tooltip="'Lihat Foto'" />
										<span v-else-if="!edit">-</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="modal-footer">
						<input v-if="edit" type="submit" class="btn btn-primary px-4" value="Perbarui" />
						<input v-else type="button" class="btn btn-secondary px-4" value="Edit" @click="edit = true" />
					</div>
				</form>
			</div>
		</div>
	</div>
	<div class="modal fade" id="lihatFoto" aria-hidden="true" aria-labelledby="lihatFoto" data-bs-keyboard="true">
		<div class="modal-dialog modal-xl modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<legend class="modal-title">Lihat Foto</legend>
					<button type="button" id="tutupLihatFoto" class="btn-close" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<img v-show="lihatFoto" :src="lihatFoto" class="w-100" alt="Preview" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Modal } from "bootstrap";
import WebSocketService from "./WebSocketService";

export default {
	data() {
		return {
			listTa: [],
			ta: this.$store.getters.getTahunAjaran,
			dataKelengkapan: [],
			pendaftar: {},
			edit: false,
			files: {
				fotoDiri: null,
				kk: null,
				akta: null,
				skl: null,
				ktpAyah: null,
				ktpIbu: null,
				ktpWali: null,
			},
			previews: {
				fotoDiri: null,
				kk: null,
				akta: null,
				skl: null,
				ktpAyah: null,
				ktpIbu: null,
				ktpWali: null,
			},
			loadingInput: {
				fotoDiri: null,
				kk: null,
				akta: null,
				skl: null,
				ktpAyah: null,
				ktpIbu: null,
				ktpWali: null,
			},
			lihatFoto: null,
			key: null,
			arrayLimit: [1, 2, 10, 25, 50, 100, 250],
			count: 0,
			pageCurrent: 1,
			pageOffset: 0,
			pageLimit: this.$store.getters.getDefaultLimit,
			pageCount: 0,
			updatedPpdb: (data) => {
				const d = JSON.parse(data);
				const pendaftarAda = this.dataKelengkapan.some((k) => k.ppdb_id == d.ppdb_id);
				const pendaftarSama = this.pendaftar?.ppdb_id == d.ppdb_id;
				if (pendaftarAda) {
					this.getBerkasPendaftar(2);
				}
				if (pendaftarSama) {
					document.getElementById("tutupLihatBerkas").click();
					document.getElementById("tutupLihatFoto").click();
				}
			},
			deletedPpdb: (data) => {
				const d = JSON.parse(data);
				const pendaftarSama = this.pendaftar?.ppdb_id == d.ppdb_id;
				if (d.tahun_ajaran_id == this.ta.tahun_ajaran_id) {
					this.getBerkasPendaftar(1);
				}
				if (pendaftarSama) {
					document.getElementById("tutupLihatBerkas").click();
					document.getElementById("tutupLihatFoto").click();
				}
			},
			insertedBerkas: (data) => {
				const d = JSON.parse(data);
				if (d.tahun_ajaran_id == this.ta.tahun_ajaran_id) {
					this.getBerkasPendaftar(1);
				}
			},
			updatedBerkas: (data) => {
				const d = JSON.parse(data);
				const pendaftarAda = this.dataKelengkapan.some((k) => k.ppdb_id == d.ppdb_id);
				const pendaftarSama = this.pendaftar?.ppdb_id == d.ppdb_id;
				if (pendaftarAda) {
					this.getBerkasPendaftar(2);
				}
				if (pendaftarSama) {
					document.getElementById("tutupLihatBerkas").click();
					document.getElementById("tutupLihatFoto").click();
				}
			},
		};
	},
	computed: {
		token() {
			return this.$store.getters.getToken;
		},
		user() {
			return this.$store.getters.getUserData;
		},
		adminKhusus() {
			return String(this.user.ket)
				.split(",")
				.some((k) => {
					return ["it", "ppdb-khusus"].includes(k);
				});
		},
	},
	watch: {
		ta() {
			this.getBerkasPendaftar(1);
		},
		pageCurrent() {
			this.pageOffset = (this.pageCurrent - 1) * this.pageLimit;
			this.getBerkasPendaftar(1);
		},
		pageLimit() {
			if (this.pageCurrent == 1) {
				this.getBerkasPendaftar(1);
			} else {
				this.pageCurrent = 1;
			}
		},
		key(val, oldVal, onCleanup) {
			let timeout = setTimeout(() => {
				this.getBerkasPendaftar(1);
			}, 500);
			onCleanup(() => clearTimeout(timeout));
		},
	},
	mounted() {
		this.getBerkasPendaftar();
		this.getListTa();
		WebSocketService.on("updated-ppdb", this.updatedPpdb);
		WebSocketService.on("deleted-ppdb", this.deletedPpdb);
		WebSocketService.on("inserted-berkas", this.insertedBerkas);
		WebSocketService.on("updated-berkas", this.updatedBerkas);
	},
	beforeUnmount() {
		WebSocketService.off("updated-ppdb", this.updatedPpdb);
		WebSocketService.off("deleted-ppdb", this.deletedPpdb);
		WebSocketService.off("inserted-berkas", this.insertedBerkas);
		WebSocketService.off("updated-berkas", this.updatedBerkas);
	},
	methods: {
		async getListTa() {
			try {
				const response = await this.axios.post(
					"/list/tahun-ajaran",
					{},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.listTa = response.data.tahun_ajaran;
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}
		},
		async handleInputFoto(event, type) {
			this.loadingInput[type] = true;

			const file = event.target.files[0];
			if (file && file.type.startsWith("image/")) {
				const maxFileSizeMB = 2;
				const maxFileSizeByte = maxFileSizeMB * 1024 * 1024;
				if (file.size > maxFileSizeByte) {
					this.loadingInput[type] = false;
					return this.$swal({
						title: "Peringatan",
						text: `Ukuran file tidak boleh melebihi ${maxFileSizeMB}MB!`,
						icon: "warning",
						confirmButtonText: "Mengerti",
					}).then(() => {
						this.$refs[type + "Ref"].value = null;
					});
				}
				setTimeout(() => {
					this.files[type] = file;
					this.previews[type] = URL.createObjectURL(file);
					this.loadingInput[type] = false;
				}, 250);
			} else {
				this.$swal({
					title: "Peringatan",
					text: "File yang Anda pilih bukan file Gambar. Silakan pilih jenis file yang sesuai!",
					icon: "warning",
					confirmButtonText: "Mengerti",
				}).then(() => {
					this.$refs[type + "Ref"].value = null;
					this.files[type] = null;
					this.previews[type] = null;
					this.loadingInput[type] = false;
				});
			}
		},
		lihatFotoModal(foto) {
			this.lihatFoto = foto;
			const modalFoto = new Modal(document.getElementById("lihatFoto"));
			modalFoto.show();
		},
		async getBerkasPendaftar(n) {
			let memuat;
			if (n != 2) {
				memuat = this.$loading.show({
					container: this.$refs.dataBerkas,
					loader: n ? "dots" : "spinner",
				});
			}
			try {
				const response = await this.axios.post(
					"/berkas",
					{
						tahun_ajaran_id: this.ta.tahun_ajaran_id,
						limit: this.pageLimit,
						offset: this.pageOffset,
						key: this.key,
					},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.dataKelengkapan = response.data.berkas;
					this.dataKelengkapan.forEach((d) => {
						if (d.persentase_kelengkapan == 0) {
							d.warna = "#000";
						} else if (d.persentase_kelengkapan < 33) {
							d.warna = "red";
						} else if (d.persentase_kelengkapan < 66) {
							d.warna = "orange";
						} else if (d.persentase_kelengkapan < 100) {
							d.warna = "#5394fd";
						} else {
							d.warna = "green";
						}
						d.kelengkapan = Math.round((d.persentase_kelengkapan + Number.EPSILON) * 100) / 100;
						d.created_at = new Date(d.created_at).toLocaleString("id-ID");
						if (d.updated_at) {
							d.updated_at = new Date(d.updated_at).toLocaleString("id-ID");
						}
					});
					this.count = response.data.count;
					this.pageCount = Math.ceil(this.count / this.pageLimit);
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}

			if (n != 2) {
				setTimeout(() => {
					memuat.hide();
				}, 250);
			}
		},
		async getBerkasPendaftarByPpdbId(p) {
			this.pendaftar = p;
			this.edit = false;
			for (let field in this.files) {
				this.files[field] = null;
				this.loadingInput[field] = null;
				this.$refs[field + "Ref"].value = null;
			}

			const lihatDetailModal = new Modal(document.getElementById("lihatDetail"));
			if (this.pendaftar?.berkas) {
				this.previews = {
					fotoDiri: this.pendaftar.berkas.foto_diri,
					kk: this.pendaftar.berkas.kk,
					akta: this.pendaftar.berkas.akta,
					skl: this.pendaftar.berkas.skl,
					ktpAyah: this.pendaftar.berkas.ktp_ayah,
					ktpIbu: this.pendaftar.berkas.ktp_ibu,
					ktpWali: this.pendaftar.berkas.ktp_wali,
				};
				lihatDetailModal.show();
				return;
			}
			try {
				const response = await this.axios.post(
					"/berkas",
					{
						ppdb_id: this.pendaftar?.ppdb_id,
					},
					{
						headers: { Authorization: this.token },
					}
				);
				if (response.data) {
					this.pendaftar.berkas = response.data.berkas;
					this.previews = {
						fotoDiri: this.pendaftar.berkas.foto_diri,
						kk: this.pendaftar.berkas.kk,
						akta: this.pendaftar.berkas.akta,
						skl: this.pendaftar.berkas.skl,
						ktpAyah: this.pendaftar.berkas.ktp_ayah,
						ktpIbu: this.pendaftar.berkas.ktp_ibu,
						ktpWali: this.pendaftar.berkas.ktp_wali,
					};
					lihatDetailModal.show();
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
					}
				} else {
					console.log(err);
				}
			}
		},
		async perbaruiData() {
			let fileTerpilih = 0;
			for (let i in this.files) {
				if (this.files[i]) {
					fileTerpilih++;
					break;
				}
			}
			if (!fileTerpilih) {
				return this.$swal({
					title: "Peringatan",
					text: `Anda belum memilih file untuk diunggah!`,
					icon: "warning",
					confirmButtonText: "Mengerti",
				});
			}

			let memuat = this.$loading.show({
				container: this.$refs.formUnggah,
				loader: "spinner",
			});

			const formData = new FormData();
			formData.append("ppdb_id", this.pendaftar?.ppdb_id);
			if (this.files.fotoDiri) formData.append("foto_diri", this.files.fotoDiri);
			if (this.files.kk) formData.append("kk", this.files.kk);
			if (this.files.akta) formData.append("akta", this.files.akta);
			if (this.files.skl) formData.append("skl", this.files.skl);
			if (this.files.ktpAyah) formData.append("ktp_ayah", this.files.ktpAyah);
			if (this.files.ktpIbu) formData.append("ktp_ibu", this.files.ktpIbu);
			if (this.files.ktpWali) formData.append("ktp_wali", this.files.ktpWali);

			try {
				const response = await this.axios.post("/berkas/tambah", formData, {
					headers: { Authorization: this.token, "Content-Type": "multipart/form-data" },
				});
				if (response.data) {
					this.$swal({
						title: "Sukses",
						text: response.data.message,
						icon: "success",
						showConfirmButton: false,
						timer: 1500,
					}).then(() => {
						document.getElementById("tutupLihatBerkas").click();
						this.edit = false;
					});
				}
			} catch (err) {
				if (err.response) {
					if (err.response.status == 401) {
						this.$swal({
							title: "Gagal",
							text: "Sesi berakhir. Silakan login ulang.",
							icon: "error",
							confirmButtonText: "Baik",
						}).then(() => {
							this.$store.dispatch("logoutUser");
							window.location.href = this.$sso + "/" + this.$appId;
						});
					} else {
						console.log(err);
						this.$swal({
							title: "Gagal",
							html: `<p class="text-danger">${err.response.data.error}</p>
                    <code class="text-secondary text-bg-secondary bg-opacity-10">code: ${err.response.data.code}<br/>
                    message: ${err.response.data.message}</code>`,
							icon: "error",
							confirmButtonText: "Baik",
						});
					}
				} else {
					console.log(err);
				}
			}

			setTimeout(() => {
				memuat.hide();
			}, 250);
		},
	},
};
</script>

<style></style>
